import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { RiskQuestionsSurveyOption } from '../../models';

@Component({
  selector: 'app-inyova-grow-optional-box',
  templateUrl: './inyova-grow-optional-box.component.html',
  styleUrls: ['./inyova-grow-optional-box.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InyovaGrowOptionalBoxComponent),
      multi: true
    }
  ],
  standalone: false
})
export class InyovaGrowOptionalBoxComponent implements ControlValueAccessor {
  @Input() title: string;
  @Input() chips: RiskQuestionsSurveyOption[];
  @Input() hasError: boolean;
  @Input() checkboxLabel: string;
  @Input() checkboxChecked: boolean;
  @Output() toggleOptional: EventEmitter<void> = new EventEmitter<void>();

  value: string | number = '';
  private onChange: (value: number | string) => void;
  private onTouched: () => void;

  writeValue(value: number): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onCheck(value: number) {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  onToggleOptional() {
    this.toggleOptional.emit();
  }
}
